import Vue from 'vue/dist/vue.esm'
import DedicatedSearch from 'components/dedicated-search';

export default function buildDedicatedSearch(element) {
  new Vue({
    el: element,
    components: {
      DedicatedSearch
    }
  })
}
